/** Indica si el texto ingresado parece un escaneo de código de barras (POS). */
export function esEntradaCodigoBarra(input: string): boolean {
  const trimmed = input.trim();
  if (!trimmed) return false;
  if (/^\d+\*.+/.test(trimmed)) return true;
  const soloDigitos = trimmed.replace(/\s/g, '');
  return /^\d{8,}$/.test(soloDigitos);
}
